import { baseApi } from "./baseApi";

const ACCOUNT_BASE_URL = "/accounts";

export const accountApi = baseApi.injectEndpoints({
  tagTypes: ["Account"],

  endpoints: (build) => ({
    addAccount: build.mutation({
      query: (body) => ({
        url: ACCOUNT_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Account", id: "LIST" }],
    }),

    listAccount: build.query({
      query: (params) => ({
        url: ACCOUNT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Account", _id })),
              { type: "Account", id: "LIST" },
            ]
          : [{ type: "Account", id: "LIST" }],
    }),

    getDDLAccountList: build.query({
      query: (params) => ({ url: `${ACCOUNT_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Account", _id })),
              { type: "Account", id: "DDL" },
            ]
          : [{ type: "Account", id: "DDL" }],
    }),

    getAccountDetail: build.query({
      query: (accountId) => `${ACCOUNT_BASE_URL}/${accountId}`,
      providesTags: (result, error, { _id }) => [
        { type: "Account", _id },
        { type: "Account", id: "LIST" },
      ],
    }),

    updateAccount: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${ACCOUNT_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "Account", id },
        { type: "Account", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListAccountQuery,
  useLazyListAccountQuery,
  useGetDDLAccountListQuery,
  useLazyGetDDLAccountListQuery,
  useAddAccountMutation,
  useGetAccountDetailQuery,
  useUpdateAccountMutation,
} = accountApi;
